export const boxShadows = {
  small: { boxShadow: `0px 4px 16px 0px rgba(0, 0, 0, 0.12)` },
  large: { boxShadow: `0px 1px 2px 0px rgba(0, 0, 0, 0.16)` },
  modal: { boxShadow: `0px 0px 4px 0px rgba(0, 0, 0, 0.2)` },
};
